var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    { staticClass: "company", attrs: { to: _vm.link } },
    [
      _c("img", {
        directives: [
          {
            name: "tippy",
            rawName: "v-tippy",
            value: _vm.rowData.country.name,
            expression: "rowData.country.name",
          },
        ],
        staticClass: "flag",
        attrs: {
          src: _vm.rowData.country.flag || "//placehold.it/24x16",
          alt: _vm.rowData.country.name,
        },
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          _vm._s(
            _vm.rowData.companyName
              ? _vm.rowData.companyName
              : _vm.rowData.projectName
          )
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }